<div class="ep_card">
  <div
    class="ep_card-header ep_card-header-icon ep_card-header-warning"
  >
    <div class="ep_card-icon">
      <i class="material-icons">sim_card_download</i>
    </div>
    <p class="ep_card-category">Download Documenti</p>
  </div>

  <div
    class="ep_card-footer"
    *ngIf="!loader.pdf && !loader.zip && downloadable"
  >
    <button
      mat-raised-button
      class="download-option"
      (click)="downloadArchivio('zip')"
    >
      <img
        src="{{ getIcon('zip') }}"
        class="image"
        alt="zip icon"
      />
      &nbsp;Archivio schede novità
    </button>
    <button
      mat-raised-button
      class="download-option"
      (click)="downloadArchivio('pdf')"
    >
      <img
        src="{{ getIcon('pdf') }}"
        class="image"
        alt="pdf icon"
      />
      &nbsp;Unico pdf delle novità
    </button>
  </div>
  <div
    class="ep_card-footer"
    *ngIf="!downloadable && !loader.downloadable"
  >
    Il download degli archivi non è ancora disponibile,
    stiamo lavorando per renderlo disponibile al pi&ugrave;
    presto
  </div>
  <div
    class="ep_card-footer"
    *ngIf="loader.downloadable"
  >
    <mat-progress-bar mode="indeterminate">
    </mat-progress-bar>
  </div>
  <div
    class="ep_card-footer"
    *ngIf="loader.pdf || loader.zip"
  >
    <div align="center">
      Download in corso ({{ percentDone }}%), ti preghiamo
      di aspettare, potrebbe volerci qualche minuto.
    </div>
    <mat-progress-bar [value]="percentDone">
    </mat-progress-bar>
  </div>
</div>
<!--   [mode]="download.state == 'PENDING' ? 'buffer' : 'determinate'"  -->
